export const BADGE_STORE_KEY = 'BADGE_STORE';
export const POST_VIEW_STORE_KEY = 'POST_VIEW_STORE';
export const LAST_SENDER_STORE_KEY = 'LAST_SENDER_STORE';
